import { spaceMedium } from '../styles/spaces';

export const buttonsWrapperStyle = {
    display        : 'flex',
    width          : '100%',
    flexDirection  : 'row-reverse' as 'row-reverse',
    justifyContent : 'center',
    marginBottom   : spaceMedium,
};

export default buttonsWrapperStyle;
